/**
 * Audio Level History Hook
 * Manages historic audio level data for waveform visualization
 */

import { useCallback, useRef } from 'react';

interface AudioLevelPoint {
  level: number;
  timestamp: number;
}

export function useAudioLevelHistory() {
  const historyRef = useRef<AudioLevelPoint[]>([]);
  const maxHistoryLength = 50; // Keep last 50 data points

  const addAudioLevel = useCallback((level: number) => {
    const now = Date.now();
    const newPoint: AudioLevelPoint = { level, timestamp: now };

    // Add to history
    historyRef.current.push(newPoint);

    // Trim history if too long
    if (historyRef.current.length > maxHistoryLength) {
      historyRef.current.shift();
    }
  }, []);

  const getHistory = useCallback(() => {
    return historyRef.current;
  }, []);

  const clearHistory = useCallback(() => {
    historyRef.current = [];
  }, []);

  return {
    addAudioLevel,
    getHistory,
    clearHistory,
  };
}
